import { ButtonStyled, GridItem, TextStyled } from '@nike/nike-design-system-components';
import uuid from 'react-uuid';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var QuickEdit = function QuickEdit(props) {
  var placements = Object.keys(props);
  var _props$mediaHost = props.mediaHost,
    mediaHost = _props$mediaHost === void 0 ? '' : _props$mediaHost;
  return /*#__PURE__*/_jsxs(GridItem, {
    style: {
      display: 'flex'
    },
    children: [/*#__PURE__*/_jsx(GridItem, {
      xs: 2,
      children: /*#__PURE__*/_jsx(TextStyled, {
        appearance: "heading2",
        placeholder: undefined,
        onPointerEnterCapture: undefined,
        onPointerLeaveCapture: undefined,
        children: "Quick Edit"
      })
    }), placements.map(function (placement) {
      var _props$placement;
      if (props !== null && props !== void 0 && (_props$placement = props[placement]) !== null && _props$placement !== void 0 && (_props$placement = _props$placement[0]) !== null && _props$placement !== void 0 && _props$placement.xfPath) {
        var path = props[placement][0].xfPath.replace('/jcr:content', '');
        return /*#__PURE__*/_jsx(GridItem, {
          xs: 2,
          children: /*#__PURE__*/_jsx(ButtonStyled
          // @ts-expect-error
          , {
            component: "a",
            size: "responsive",
            onClick: function onClick() {
              return window.open("".concat(mediaHost === null || mediaHost === void 0 ? void 0 : mediaHost.replace('publish', 'author'), "/editor.html").concat(path, ".html"), '_blank');
            },
            children: placement
          })
        }, uuid());
      }
      return (
        /*#__PURE__*/
        // TODO: Somehow hitting this ~2 times putting empty div to not break grid
        // eslint-disable-next-line react/jsx-key
        _jsx("div", {})
      );
    })]
  });
};
export default QuickEdit;